export type ActionPlanStep = 'none' | 'focus' | 'selection' | 'thankYou' | 'aggregated';

export interface ActionPlanStepInput {
  guid: string | undefined;
  isDirectActionPlanRoute: boolean;
  isCheckingBackend: boolean;
  hasAggregatedData: boolean;
  hasLocalSubmission: boolean;
}

export class ActionPlanStepResolver {
  public static resolveStep(input: ActionPlanStepInput): ActionPlanStep {
    const {
      guid,
      isDirectActionPlanRoute,
      isCheckingBackend,
      hasAggregatedData,
      hasLocalSubmission,
    } = input;

    if (!guid || !isDirectActionPlanRoute) {
      return 'none';
    }

    if (isCheckingBackend) {
      return this.resolveLoadingStep(hasLocalSubmission);
    }

    return this.resolveFinalStep(hasAggregatedData, hasLocalSubmission);
  }

  private static resolveLoadingStep(hasLocalSubmission: boolean): ActionPlanStep {
    return hasLocalSubmission ? 'thankYou' : 'focus';
  }

  private static resolveFinalStep(
    hasAggregatedData: boolean,
    hasLocalSubmission: boolean,
  ): ActionPlanStep {
    if (hasAggregatedData) {
      return 'aggregated';
    }

    if (hasLocalSubmission) {
      return 'thankYou';
    }

    return 'focus';
  }

  public static shouldSyncLocalStorage(
    hasAggregatedData: boolean,
    hasLocalSubmission: boolean,
  ): boolean {
    return hasAggregatedData && !hasLocalSubmission;
  }

  public static resolveEffectiveStep(
    derivedStep: ActionPlanStep,
    userFlowStep: ActionPlanStep,
  ): ActionPlanStep {
    if (derivedStep === 'focus') {
      return userFlowStep;
    }

    return derivedStep;
  }
}
